import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PlanningHorizonLayer from "../components/PlanningHorizonLayer";

const PlanningHorizonPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Planning Lead Time">

        {/* PlanningHorizonLayer */}
        <PlanningHorizonLayer />
      </MasterLayout>
    </>
  );
};

export default PlanningHorizonPage;